module.exports = __webpack_public_path__ + "img/icon-clinic.8129d66.svg";